@if (bookedReservations.length > 0 || !activityService.loaderRunning) {
  <div class="page-title-section row px-3 m-0 pt-5 pb-4 flex-column">
    <div class="main-title main-theme-color d-flex justify-content-center text-center text-uppercase">
    {{(bookedReservations.length > 0 ? 'confirmation' : 'noBookings') | translate}}</div>
    <div class="sub-title secondary-theme-color d-flex justify-content-center text-center text-uppercase">
      {{(bookedReservations.length > 0 ? 'bookingIsConfirmed' : 'hopeYouVisitUsAgain') | translate}}
    </div>
  </div>
}
<div class="container">
  <div class="p-0 pt-3 col-12 d-flex justify-content-center">
    @if (bookedReservations.length > 0) {
      <div class="p-0 col-lg-7 col-12">
        @if (showQRCode && cartBookingId && bookedReservations.length > 0) {
          <div
            class="d-flex justify-content-center">
            <qrcode [qrdata]="cartBookingId" [allowEmptyString]="true" [cssClass]="'center'" [colorDark]="'#000000ff'"
              [colorLight]="'#ffffffff'" [elementType]="'canvas'" [errorCorrectionLevel]="'M'" [margin]="4"
            [scale]="1" [width]="300"></qrcode>
          </div>
        }
        <!-- Add multi to show multiple expansion parallely or only one expansion to be open at a time -->
        <mat-accordion multi="true" class="activity-accordian-accordian">
          <!-- Remove disabled when having more than 1 slot bookings -->
          @for (bookingDetail of bookedReservations; track bookingDetail; let i = $index) {
            <div>
              <div class="d-inline-block p-2 activity-confitmation-code">
                <span class="activity-description-bold">{{'confirmationCode' | translate}}: </span>
                <span class="activity-description-bolder">{{bookingDetail.ConfirmationCode}}</span>
                <span class="activity-description-bold ms-3">{{'bookingReferenceId' | translate}}: </span>
                <span class="activity-description-bolder">{{bookingDetail.BookingReferenceId}}</span>
              </div>
              <mat-expansion-panel  hideToggle
                class=" mt-0 my-3 activity-accordian-panel">
                <mat-expansion-panel-header class="activity-panel-header">
                  <div
                    class="w-100 order-summary-short-detail-section p-3 mx-2 shadow d-flex flex-row justify-content-between">
                    <div
                      class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center">
                      <mat-icon>card_travel</mat-icon>
                      <div class="px-2 order-details-activity-name text-wrap text-center">
                      {{ bookingDetail.isDining ? bookingDetail.RestaurantName : bookingDetail.SpecialMeal?.Name}}</div>
                    </div>
                    <div class="order-summary-spacer mx-2"></div>
                    <div
                      class="guest-count activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center">
                      <mat-icon>person</mat-icon>
                      <div class="px-2 text-center">{{bookingDetail.Size}}</div>
                    </div>
                    <div class="order-summary-spacer mx-2"></div>
                    <div
                      class="activity-selected-date activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center">
                      <mat-icon>calendar_today</mat-icon>
                      <div class="px-2 text-center">{{(bookingDetail.StartDate | localizeDate: 'DD MMMM YYYY')}}</div>
                    </div>
                    @if (bookingDetail.activityStartTime || bookingDetail.isOpenBooking) {
                      <div class="order-summary-spacer mx-2"></div>
                    }
                    @if (bookingDetail.activityStartTime || bookingDetail.isOpenBooking) {
                      <div
                        class="activity-selected-date activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center">
                        <mat-icon>access_time</mat-icon>
                        <div class="px-2 text-center">{{(bookingDetail.activityStartTime || bookingDetail.SeatingTime) | localizeDate:'LT'}}
                          @if (!bookingDetail.isDining && (bookingDetail.activityEndTime || bookingDetail.DepartureTime)) {
                            {{'to' | translate}} {{(bookingDetail.activityEndTime || bookingDetail.DepartureTime) | localizeDate:'LT'}}
                          }
                        </div>
                      </div>
                    }
                    @if ((bookingDetail.activityStartTime || bookingDetail.isOpenBooking) && displayModifyButton) {
                      <div class="order-summary-spacer mx-2"></div>
                    }
                    @if ((bookingDetail.activityStartTime || bookingDetail.isOpenBooking) && displayModifyButton) {
                      <div
                        class="activity-selected-edit-action activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center"
                        (click)="$event.stopPropagation();getOrderDetails(true, 'modify', bookingDetail)">
                        <mat-icon matTooltip="{{'modify' | translate}}">
                          <mat-icon>mode_edit</mat-icon>
                        </mat-icon>
                      </div>
                    }
                    @if ((bookingDetail.activityStartTime || bookingDetail.isOpenBooking) && displayCancelButton && bookingDetail?.CanBeCancel) {
                      <div class="order-summary-spacer mx-2"></div>
                    }
                    @if ((bookingDetail.activityStartTime || bookingDetail.isOpenBooking) && displayCancelButton && bookingDetail?.CanBeCancel) {
                      <div
                        class="activity-selected-cancel-action activity-description-bold d-flex flex-wrap justify-content-center align-items-center text-center"
                        (click)="$event.stopPropagation();getOrderDetails(true, 'cancel', bookingDetail)">
                        <mat-icon matTooltip="{{'cancel' | translate}}">
                          <mat-icon>highlight_off</mat-icon>
                        </mat-icon>
                      </div>
                    }
                  </div>
                </mat-expansion-panel-header>
                <div class="price-splitup-section">
                  <div class="p-0 col-12 price-splitup-table d-flex flex-column">
                    @if (bookingDetail?.CoverTypeQuantities && bookingDetail?.CoverTypeQuantities.length > 0) {
                      <div
                        class="py-1 price-table-header d-flex flex-row justify-content-start">
                        <div class="p-0 col-8">
                          <div class="activity-description-bolder">{{'description' | translate}}</div>
                        </div>
                        <div class="p-0 col-4">
                          <div class="activity-description-bolder d-flex justify-content-center">{{'qty' |
                          translate}}</div>
                        </div>
                      </div>
                    }
                    @for (cover of bookingDetail.CoverTypeQuantities; track cover) {
                      <div class="py-1 price-table-data-cell d-flex flex-row justify-content-start"
                        >
                        <div class="p-0 col-8">
                          <div class="activity-description-bold">{{cover.CoverTypeName}}</div>
                          <div class="py-2 order-summary-sub-detail activity-description">
                          </div>
                        </div>
                        <div class="p-0 col-4">
                          <div class="activity-description-bold d-flex justify-content-center">
                          {{cover.Covers}}</div>
                        </div>
                      </div>
                    }
                    <div class="d-flex flex-column"
                      [ngClass]="{'order-cost-summary-section': bookingDetail?.CoverTypeQuantities && bookingDetail?.CoverTypeQuantities.length > 0}">
                      @if (bookingDetail.State === 4) {
                        <div
                          class="py-3 order-summary-refund-detail d-flex flex-row justify-content-start"
                          [ngClass]="bookingDetail.State == 4 ? 'mt-4' : 'my-4'">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{'totalCancellationCharges' |
                            translate}}</div>
                          </div>
                          <div class="p-0 col-4">
                            <div class="activity-description-bolder d-flex justify-content-center">
                              {{bookingDetail.OperationCurrency}}{{bookingDetail.cancellationCharges | currencyDecimalFormatter}}
                            </div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && (bookingDetail.TaxAmount || bookingDetail.VAT)) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start"
                          [ngClass]="bookingDetail.State === 4 ? 'mb-4' : ''">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{(bookingDetail.isDining ? (bookingDetail.SpecialMeal?.Name || ('BasePrice' | translate) ) : 'sessionCharges') | translate}}</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">{{bookingDetail.OperationCurrency}}{{
                              (bookingDetail.isDining ? (bookingDetail.NoShowFeeAmount ? bookingDetail.NoShowFeeAmount : (bookingDetail?.SpecialMealAmount ? bookingDetail?.SpecialMealAmount : 0) +
                              bookingDetail?.RatePlanAmount) : bookingDetail.RatePlanAmount) |
                            currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && bookingDetail.AddonItemAmount) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start"
                          [ngClass]="bookingDetail.State === 4 ? 'mb-4' : ''">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">Addon Amount</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">{{bookingDetail.OperationCurrency}}{{
                              (bookingDetail.AddonItemAmount ? bookingDetail.AddonItemAmount : 0) |
                            currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && bookingDetail.minRateAdjustmentAmount) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start"
                          [ngClass]="bookingDetail.State === 4 ? 'mb-4' : ''">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{'MinRateAdjustment' | translate}}</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">{{bookingDetail.OperationCurrency}}{{
                              bookingDetail.minRateAdjustmentAmount |
                            currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && bookingDetail.serviceChargeAmount > 0) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{'serviceCharges'| translate}}</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">
                              {{bookingDetail.OperationCurrency}}{{bookingDetail.serviceChargeAmount |
                            currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && bookingDetail.TaxOnServiceChargeAmount) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{'taxOnserviceCharge' | translate}}</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">
                              {{bookingDetail.OperationCurrency}}{{(bookingDetail.TaxOnServiceChargeAmount ||  0) |
                            currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && bookingDetail.VATOnServiceChargeAmount) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{'VATOnserviceCharge' | translate}}</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">
                              {{bookingDetail.OperationCurrency}}{{(bookingDetail.VATOnServiceChargeAmount ||  0) |
                            currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && (bookingDetail.TotalDeposit && bookingDetail.TotalDeposit > 0)) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{'Deposit Total' | translate}}</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">
                            {{bookingDetail.OperationCurrency}}{{bookingDetail?.TotalDeposit | currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && bookingDetail.TaxAmount) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{'taxAmount' | translate}}</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">
                              {{bookingDetail.OperationCurrency}}{{((bookingDetail.TaxAmount || 0) + (bookingDetail.AddonItemTaxAmount || 0) +
                            (bookingDetail.minRateAdjustmentTaxAmount || 0))| currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      @if (bookingDetail.State !== 4 && bookingDetail.VAT) {
                        <div
                          class="py-3 order-summary-total-price d-flex flex-row justify-content-start">
                          <div class="p-0 col-8">
                            <div class="activity-description-bolder">{{'VAT' | translate}}</div>
                          </div>
                          <div class="p-0 col-4 d-flex justify-content-center">
                            <div class="activity-description-bolder">
                            {{bookingDetail.OperationCurrency}}{{(bookingDetail.VAT || 0) | currencyDecimalFormatter}}</div>
                          </div>
                        </div>
                      }
                      <!-- <div @if (bookingDetail.State !== 4 && bookingDetail.AddonItemTaxAmount) {
                      class="py-3 order-summary-total-price d-flex flex-row justify-content-start">
                      <div class="p-0 col-8">
                        <div class="activity-description-bolder">Addon Tax Amount</div>
                      </div>
                      <div class="p-0 col-4 d-flex justify-content-center">
                        <div class="activity-description-bolder">
                          {{bookingDetail.OperationCurrency}}{{ (bookingDetail.AddonItemTaxAmount ? bookingDetail.AddonItemTaxAmount : 0)|
                        currencyDecimalFormatter}}</div>
                      </div>
                    </div> } -->
                    @if (bookingDetail.RatePlanAmount || bookingDetail.SpecialMealAmount || bookingDetail.NoShowFeeAmount) {
                      <div
                        class="py-3 order-summary-total-price d-flex flex-row justify-content-start">
                        <div class="p-0 col-8">
                          <div class="activity-description-bolder">{{(bookingDetail.State === 4 ?
                            'totalRefundAmount'
                            :
                          'totalSessionCharges') | translate}}</div>
                        </div>
                        <div class="p-0 col-4 d-flex justify-content-center">
                          <div class="activity-description-bolder">{{bookingDetail.OperationCurrency}}{{
                          bookingDetail?.GrandTotalSummary?.GrandTotal | currencyDecimalFormatter}}</div>
                        </div>
                      </div>
                    }
                    @if (!bookingDetail.hideEditCancel && bookingDetail.State !== 4) {
                      <div class="py-3 order-summary-cancel-modify d-flex flex-row justify-content-around">
                        <div class="p-0 col-6 d-flex my-3 justify-content-center">
                          @if (displayCancelButton && bookingDetail?.CanBeCancel) {
                            <button mat-button type="button"
                              class="p-3 session-cancel-button booked-activity-buttons text-center"
                            (click)="getOrderDetails(true, 'cancel', bookingDetail)">{{'cancel' | translate}}</button>
                          }
                        </div>
                        <div class="p-0 col-6 d-flex my-3 justify-content-center">
                          @if (displayModifyButton) {
                            <button mat-button type="button"
                              class="session-modify-button booked-activity-buttons p-3 text-center"
                              (click)="getOrderDetails(true, 'modify', bookingDetail)">
                              {{'modify' | translate}}
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        }
      </mat-accordion>
      @if (grandTotal) {
        <div class="py-4 m-2 px-3 order-summary-grand-total d-flex flex-row justify-content-between">
          <div class="p-0 col-8">
            <div class="activity-title text-uppercase">{{'grandTotal' | translate}}</div>
          </div>
          <div class="p-0 col-4 d-flex justify-content-center">
            <div class="d-flex align-items-center activity-title">{{currency}}{{
              grandTotal | currencyDecimalFormatter}}
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (!activityService.loaderRunning && bookedReservations.length === 0) {
    <div
      class="col-sm-12 no-slots-message activity-no-data-error activity-description-bolder text-center">
      {{'noBookingCurrently' | translate}}<br/><br/>{{ 'clickToContinueShopping' | translate }}
    </div>
  }
</div>
<div class="py-3 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-wrap justify-content-center">
  <div class="p-0 col-lg-4 col-md-5 col-sm-12 col-12 d-flex my-3 justify-content-center">
    <button mat-button type="button" class="activity-buttons activity-confirm-buttons p-3 text-center"
      (click)="continueToBooking()">{{'continue' | translate}}
    </button>
  </div>
</div>
</div>